import { Header1, Instruction } from "../../BlockComponent";

import { LastCard } from "../common";

export const Content_8_1_A = [
  Instruction(`typography_0_0_0`),
  Instruction(`typography_1_0_0`),
  Instruction(`typography_2_0_0`),
  Instruction(`typography_3_0_0`),
  Instruction(`typography_4_0_0`),
  Instruction(`typography_5_0_0`),

  Header1(`typography_6_0_0`),
  Instruction(`typography_7_0_0`),
  Instruction(`typography_8_0_0`),
  Instruction(`typography_9_0_0`),
  Instruction(`typography_10_0_0`),
  Instruction(`typography_11_0_0`),
  Instruction(`typography_12_0_0`),
  Instruction(`typography_13_0_0`),

  Header1(`typography_14_0_0`),
  Instruction(`typography_15_0_0`),
  Instruction(`typography_16_0_0`),
  Instruction(`typography_17_0_0`),
  Instruction(`typography_18_0_0`),
  Instruction(`typography_19_0_0`),

  Header1(`typography_20_0_0`),
  Instruction(`typography_21_0_0`),
  Instruction(`typography_22_0_0`),
  Instruction(`typography_23_0_0`),
  Instruction(`typography_24_0_0`),
  Instruction(`typography_25_0_0`),
  Instruction(`typography_26_0_0`),

  Header1(`typography_26_0_1`),
  Instruction(`typography_26_0_2`),
  Instruction(`typography_26_0_3`),
  Instruction(`typography_26_0_4`),
  Instruction(`typography_26_0_5`),
  Instruction(`typography_26_0_6`),
  Instruction(`typography_26_0_7`),
  Instruction(`typography_26_0_8`),
  Instruction(`typography_26_0_9`),

  Header1("typography_26_0_10"),
  Instruction(`typography_26_0_11`),
  Instruction(`typography_26_0_12`),
  Instruction(`typography_26_0_13`),
  Instruction(`typography_26_0_14`),
  Instruction(`typography_26_0_15`),
  Instruction(`typography_26_0_16`),
  Instruction(`typography_26_0_17`),
  Instruction(`typography_26_0_18`),

  Header1("typography_26_0_19"),
  Instruction(`typography_26_0_20`),
  Instruction(`typography_28_0_0`),
  Instruction(`typography_29_0_0`),
  Instruction(`typography_30_0_0`),
  Instruction(`typography_31_0_0`),
  Instruction(`typography_32_0_0`),

  ...LastCard,
];
